
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prices-and-payment/price-promise/request",
      function () {
        return require("private-next-pages/prices-and-payment/price-promise/request.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prices-and-payment/price-promise/request"])
      });
    }
  